import { render, staticRenderFns } from "./team-view-page.vue?vue&type=template&id=12328b74&scoped=true&"
import script from "./team-view-page.vue?vue&type=script&lang=js&"
export * from "./team-view-page.vue?vue&type=script&lang=js&"
import style0 from "./team-view-page.vue?vue&type=style&index=0&id=12328b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12328b74",
  null
  
)

export default component.exports